const rowIcon = (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 2.82258C0 2.36828 0.343976 2 0.768293 2H7.68293C8.81444 2 9.73171 2.98209 9.73171 4.19355V16.8065C9.73171 18.0179 8.81444 19 7.68293 19H0.768293C0.343976 19 0 18.6317 0 18.1774C0 17.7231 0.343976 17.3548 0.768293 17.3548H7.68293C7.9658 17.3548 8.19512 17.1093 8.19512 16.8065V4.19355C8.19512 3.89068 7.9658 3.64516 7.68293 3.64516H0.768293C0.343976 3.64516 0 3.27688 0 2.82258Z"
      fill="#6B00DF"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21 2.82258C21 2.36828 20.656 2 20.2317 2H13.3171C12.1856 2 11.2683 2.98209 11.2683 4.19355V16.8065C11.2683 18.0179 12.1856 19 13.3171 19H20.2317C20.656 19 21 18.6317 21 18.1774C21 17.7231 20.656 17.3548 20.2317 17.3548H13.3171C13.0342 17.3548 12.8049 17.1093 12.8049 16.8065V4.19355C12.8049 3.89068 13.0342 3.64516 13.3171 3.64516H20.2317C20.656 3.64516 21 3.27688 21 2.82258Z"
      fill="#6B00DF"
    />
  </svg>
);

export default rowIcon;
